import { useState } from "react";
import "./styles.css";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import "react-tabs/style/react-tabs.css";
import { InputText } from "primereact/inputtext";
import api from "src/services/api";

export default function PerfilUsuario(props) {
  const [nome, setNome] = useState("");
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [permissao, setPermissao] = useState("");

  const handleSalvarPerfil = async () => {
    try {
      const response = await api.post("/api/salvarPerfil", {
        nome,
        nomeUsuario,
        senha,
        permissao,
      });

      if (response.data.success) {
        alert("Perfil salvo com sucesso!");
      } else {
        alert("Erro ao salvar perfil. Por favor, tente novamente.");
      }
    } catch (error) {
      console.error("Erro:", error);
      alert(
        "Ocorreu um erro ao salvar o perfil. Por favor, tente novamente mais tarde."
      );
    }
  };

  const breadcrumbItems = [
    { label: "Configurações", url: "/configuracoes" },
    { label: "Usuário", url: "/usuario" },
    { label: "Perfil do Usuário", url: "/perfil" },
  ];

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <BreadCrumb
        model={breadcrumbItems}
        home={{ label: "Home", url: "/" }}
        style={{
          marginTop: "41px",
          marginRight: "600px",
          border: "none",
          color: "#B7D400!important",
        }}
      />

      <p
        style={{
          fontSize: "35px",
          fontStyle: "normal",
          fontWeight: "700",
          color: "#006998",
          marginTop: "-15px",
        }}
      >
        Perfil do Usuário
      </p>
      <div
        style={{ width: "1000px", display: "flex", justifyContent: "center" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1372"
          height="10"
          viewBox="0 0 1372 10"
          fill="none"
        >
          <g filter="url(#filter0_d_110_89)">
            <path
              d="M4 1L1368 1.00012"
              stroke="#006998"
              strokeOpacity="0.55"
              strokeWidth="2"
              shapeRendering="crispEdges"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_110_89"
              x="0"
              y="0"
              width="1372"
              height="10"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0.15 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_110_89"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_110_89"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <fieldset
        style={{
          width: "1000px",
          minHeight: "250px",
          height: "350px",
          border: "1px solid #006998",
          marginTop: "35px",
          fontWeight: "bold",
          color: "black",
          borderRadius: "8px",
        }}
      >
        <legend style={{ fontSize: "20px", fontWeight: 400, color: "black" }}>
          Informações do usuário
        </legend>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: "1", marginRight: "20px" }}>
              <p style={{ marginTop: "10px", fontWeight: "400" }}>Nome </p>
              <InputText
                style={{
                  width: "100%",
                  display: "flex",
                  marginTop: "-10px",
                  borderColor: "#006998",
                  fontStyle: "italic",
                }}
                placeholder="Insira aqui o nome do cliente"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
              />
            </div>
            <div style={{ flex: "1" }}>
              <p style={{ marginTop: "10px", fontWeight: "400" }}>
                Nome de Usuário
              </p>
              <InputText
                style={{
                  width: "100%",
                  display: "flex",
                  marginTop: "-10px",
                  borderColor: "#006998",
                  fontStyle: "italic",
                }}
                placeholder="Insira aqui o nome de usuário utlizado para login"
                value={nomeUsuario}
                onChange={(e) => setNomeUsuario(e.target.value)}
              />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: "1", marginRight: "20px" }}>
              <p style={{ marginTop: "10px", fontWeight: "400" }}>Senha</p>
              <input
                type="password"
                style={{
                  width: "100%",
                  height: "45px",
                  borderRadius: "6px",
                  display: "flex",
                  marginTop: "-10px",
                  borderColor: "#006998",
                  color: "#006998",
                  fontStyle: "italic",
                }}
                placeholder=""
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
              />
            </div>
            <div style={{ flex: "1", position: "relative" }}>
              <p style={{ marginTop: "10px", fontWeight: "400" }}>
                Permissões
              </p>
              <div style={{ position: "relative" }}>
                <select
                  style={{
                    width: "100%",
                    height: "45px",
                    display: "flex",
                    marginTop: "-10px",
                    fontStyle: "italic",
                    borderRadius: "6px",
                    fontSize: "14px",
                    borderColor: "#006998",
                    paddingRight: "30px",
                    // Adicionando espaço para o ícone
                  }}
                  value={permissao}
                  onChange={(e) => setPermissao(e.target.value)}
                >
                  <option value="">Selecione as permissões para o usuário</option>
                  <option value="permissao1">Ata 1</option>
                  <option value="permissao2">Ata 2</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "30px",
          }}
        >
          <Button
            label="Cancelar"
            className="p-button-outlined p-button-primary"
            style={{ marginLeft: "10px", color: "red" }}
          />

          <Button
            label="Confirmar"
            className="p-button-outlined p-button-primary"
            style={{
              marginLeft: "10px",
              color: "#FFF",
              backgroundColor: "#3900DB",
            }}
            onClick={handleSalvarPerfil}
          />
        </div>
      </fieldset>
    </div>
  );
}
